import { call, put, takeLatest } from "redux-saga/effects"
import { GET_TEMPLATE_WATCHER, UPLOAD_TEMPLATE_WATCHER } from "./constants"
import axios from "axios"
import { push } from "connected-react-router"

import {
  getTemplateFailed,
  getTemplateSuccess,
  uploadTemplateFailed,
  uploadTemplateSuccess,
} from "./actions"
import api from "../../utils/api"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { TYPE_FETCHING } from "../../utils/constants"
import { LOCAL_TOKEN } from "../../utils/storage"

function getTemplateApi(payload) {
  woopraTrack("Descargar plantilla de planes de accion")
  return api(
    `action-plans/measure/${payload.idMeasure}/export/xlsx/template`,
    TYPE_FETCHING.get
  )
}

function getTemplateApiProgress(payload) {
  return api(
    `action-plans/measure/${payload.idMeasure}/export/xlsx/progress`,
    TYPE_FETCHING.get
  )
}

function messageProgress(text) {
  message.loading(text, 0)
}

function messageDestroy() {
  message.destroy()
}

function messageError(text) {
  message.error(text)
}

function messageSuccess(text) {
  message.success(text)
}

function downloadTemplate(url) {
  location.replace(url)
}

export function* getTemplateSaga(action) {
  try {
    yield call(messageProgress, "Descargando plantilla")
    yield call(getTemplateApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 2000))
      data = yield call(getTemplateApiProgress, action.payload)
      if (data[0].status === "Complete") {
        break
      }
    }
    yield call(downloadTemplate, data[0].url)
    yield call(messageDestroy)
    yield call(messageSuccess, "Plantilla descargada.")
    yield put(getTemplateSuccess())
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageError, "Error al descargar plantilla.")
    yield put(getTemplateFailed())
  }
}

// UPLOAD TEMPLATE
function uploadTemplate(payload) {
  const token = LOCAL_TOKEN()
  const measureId = localStorage.getItem("currentMeasure")
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}action-plans/measure/${measureId}/import/xlsx`,
    headers: { Authorization: `Bearer ${token}` },
    data: payload,
  })
}

function uploadTemplateProgress(payload) {
  const token = LOCAL_TOKEN()
  const measureId = localStorage.getItem("currentMeasure")
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}action-plans/measure/${measureId}/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${token}` },
    params: payload,
  })
}

export function* uploadTemplateSaga(action) {
  try {
    yield call(messageProgress, "Cargando archivo")

    const uploadData = yield call(uploadTemplate, action.payload)
    const timestamp = { timestamp: uploadData.data.timestamp }
    const measureId = localStorage.getItem("currentMeasure")

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress, timestamp)

      if (data.status === 200) {
        yield put(uploadTemplateSuccess(data.data))
        yield call(messageDestroy)
        yield call(messageSuccess, "Archivo importado")
        yield put(
          push(
            `/action-plans/import/${measureId}/summary?time=${timestamp.timestamp}`
          )
        )
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.error, 5)
        yield put(uploadTemplateFailed())
        break
      }
    }
  } catch (e) {
    console.error("error", e)
    yield call(messageDestroy)
    yield call(messageError, "Error al importar el archivo")
    yield put(uploadTemplateFailed())
  }
}

export default function* actionPlansImportSaga() {
  yield takeLatest(GET_TEMPLATE_WATCHER, getTemplateSaga)
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateSaga)
}
